<template>
    <div>
        <div class="content">

            <b-container fluid class="mt-4">

                <stats-card title="Roles &amp; Permissions" type="default" sub-title="Edit Role" icon="fas fa-shield-alt">

                    <template slot="actions">
                        <a class="dropdown-item" v-if="roleData.status != 'deleted'" @click="showDeleteModal = true" href="javascript:void(0)">Delete Role</a>
                        <a class="dropdown-item" v-if="roleData.status != 'active'" @click="activateRole" href="javascript:void(0)">Activate Role</a>
                    </template>

                    <template slot="append">

                        <b-card no-bod class="tab-wrapper">
                            
                            <div class="tab-container" v-if="availablePermissions">
                                <div>

                                    <base-alert type="danger" v-if="roleData.status =='deleted'">
                                        This role is currently <strong>deleted</strong>
                                    </base-alert>

                                    <base-alert type="danger" v-if="roleData.status !='deleted'">
                                        You're editing a LIVE role so better know what you're doing!
                                    </base-alert>

                                    <base-alert>
                                        This role was created on {{roleData.dateCreated}}
                                    </base-alert>

                                    <base-input label="Name" v-model="newRoleData.name" placeholder=""></base-input>
                                    <base-input label="Description" v-model="newRoleData.description" placeholder=""></base-input>

                                    <label>Included permissions</label>

                                    <card class="no-border-card" body-classes="" footer-classes="">
                                        
                                        <div >

                                            <b-col cols="12" class="d-flex justify-content-between flex-wrap align-items-center">
                                                <div>
                                                    <base-input v-on:input="filterPermissions" v-model="permissionsFilter"  placeholder="Filter permissions"> </base-input>
                                                </div>
                                                <div>
                                                    <base-switch onText="All" offText="None"  v-on:input="onPermissionsToggle"></base-switch>
                                                </div>
                                            </b-col>

                                            <el-table
                                                class="table-responsive table-flush"
                                                header-row-class-name="thead-light"
                                                row-key="id"
                                                :data="filteredPermissions"
                                                >
                                                <el-table-column label="Permission" prop="description" sortable>
                                                    <template v-slot="{ row }">
                                                        <b>{{ row.description }}</b>
                                                    </template>
                                                </el-table-column>

                                                <el-table-column label="System name" prop="permission" sortable>
                                                    <template v-slot="{ row }">
                                                        <pre>{{ row.permission }}</pre>
                                                    </template>
                                                </el-table-column>
                                                
                                                <el-table-column label="Granted" prop="active" sortable align="center">
                                                    <template v-slot="{ row }">
                                                        <!-- <div class="d-flex"> -->
                                                            <base-switch v-on:input="onPermissionToggle(row.permission)" v-model="permissionsMatrix[row.permission]"></base-switch>
                                                        <!-- </div> -->
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                                
                                        </div>
                                    </card>
                                </div>

                                <b-row align-v="center" align-h="between" class="">
                                    <b-col cols="12" align="right">
                                        <base-button type="success" @click="updateRole">
                                            Update Role
                                        </base-button>
                                    </b-col>
                                </b-row>

                            </div>
                        </b-card>
                    </template>
                </stats-card>
            </b-container>
        </div>

        <modal :show.sync="showDeleteModal">
            <h6 slot="header" class="modal-title">Delete Role</h6>

            <base-alert type="danger">
                Are you sure you want to <strong>delete</strong> this role? 
            </base-alert>

            <template slot="footer">
                <base-button type="blank" @click="showDeleteModal = false">Cancel</base-button>
                <base-button type="danger" @click="deleteRole">Yes, delete</base-button>
            </template>
        </modal>

        
    </div>
</template>

<script>

import api from '@/api'
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip } from 'element-ui';
import { RoleModel } from '@/models/access/role'

export default {
  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
        roleData: null,
        newRoleData: null,
        availableRoles: null,
        availablePermissions: null,
        filteredPermissions: null,
        permissionsMatrix: {},
        permissionsFilter: '',
        showConfirmChanges: false,
        showConfirmDelete: false,
        hasNoPermissions: false,
        showAddRole: false,
        addRoleSelected: null,
        activeTab: 0,
        showDeleteModal: false
    };
  },
  created: async function() {
    await this.fetchRole();
  },
  methods: {
    activateRole: async function() {
        this.$emit('loading', true);    
        await api.updateRole(this.roleData.id,{
            status: 'active'
        })
        this.$emit('onApiResult', "Role is now active");
        this.availablePermissions = null
        this.fetchRole()

    },
    deleteRole: async function() {
        this.showDeleteModal = false
        this.$emit('loading', true);    
        await api.updateRole(this.roleData.id,{
            status: 'deleted'
        })
        this.$emit('onApiResult', "Role has been deleted");
        this.availablePermissions = null
        this.fetchRole()

    },
    updateRole: async function() {
        this.newRoleData.allows = []
        for(let x in this.permissionsMatrix) {
            if(this.permissionsMatrix[x]) {
                this.newRoleData.allows.push(x)
            }
        }

        // compare original / new role data allows
        let removedPermissions = this.roleData.allows.filter((p) => !this.newRoleData.allows.includes(p))
        let addedPermissions = this.newRoleData.allows.filter((p) => !this.roleData.allows.includes(p))

        this.$emit('loading', true);    
        await api.updateRole(this.roleData.id,this.newRoleData.exportToCreate())
        if(addedPermissions.length > 0) await api.addRolePermissions(this.roleData.id,addedPermissions)
        if(removedPermissions.length > 0) await api.removeRolePermissions(this.roleData.id,removedPermissions)
        this.$emit('loading', false);
        this.$emit('onApiResult', "Role has been updated");

    },
    showConfirmPermissionsChanges: function() {
        this.showConfirmChanges = true;
    },
    filterPermissions: function(label) {
        let allPermissions = this.availablePermissions
        if(label.length > 2) {
            this.filteredPermissions = allPermissions.filter((p) => p.description.toLowerCase().indexOf(label.toLowerCase()) != -1 || p.permission.indexOf(label.toLowerCase()) != -1);
        }
        else {
            this.filteredPermissions = allPermissions;
        }
    },
    onPermissionToggle: function(name) {
    },
    onPermissionsToggle: function(all) {
        for(let p in this.availablePermissions) {
            this.permissionsMatrix[this.availablePermissions[p].permission] = all;
        }
    },
    getAvailablePermissions: async function() {
        this.$emit('loading', true);
        const results = await api.getRole(this.$route.params.id)
        
        this.roleData = new RoleModel(results);
        this.newRoleData = new RoleModel(results);

        const p = await api.getPermissions()

        this.$emit('loading', false);

        this.availablePermissions = p.permissions;
        this.filteredPermissions = p.permissions;

        this.onViewEditPermissions()
    },
    fetchRole: async function() {
        if(!this.availablePermissions) {
            await this.getAvailablePermissions();
        }
    },
    hasPermission: function(name) {
        return this.newRoleData.allows.filter((a) => a == name).length > 0;
    },
    onViewEditPermissions: function() {
        this.permissionsMatrix = {};
        for(let p in this.availablePermissions) {
            this.permissionsMatrix[this.availablePermissions[p].permission] = this.hasPermission(this.availablePermissions[p].permission);  
        }
    }
  }
};
</script>
